<p>reallowsingle works!</p>
